<script>
import {AxiosHelper} from '@src/utils/utils';
import Datatable from '@components/Datatable';

export default {
	components: { Datatable },
	props : {
	},
  data() {
    return {
			tableData : [],

			tableOption : {
				scrollY: 400,
				paging : false,
				searching: false,
				lengthChange: false,
				columns : [
					{data : 'ky_norae_no', },
					{data : 'norae_no', width : 50},
					{data : 'tj_norae_no',  },
				],
				columnDefs : [
					{
						render : (data, type, row) => {
							return `
								${data} ${row.ky_artist} - ${row.ky_title} => ${row.ky_song_path}
							`;
						},
						targets : 0
					},
					{
						render : (data, type, row) => {
							if(row.ky_song_path !== row.tj_song_path) {
								return `
									<a href="javascript:;" data-type="execLink" ><i class="mdi mdi-link-off"></i></a>	
								`;
							}

							return `
								<i class="mdi mdi-link"></i>
							`;
						},
						targets : 1
					},

					{
						render : (data, type, row) => {
							return `
								${data} ${row.tj_artist} - ${row.tj_title} => ${row.tj_song_path}
							`;
						},
						targets : 2
					},
				]
			},


    }
	},
	created() {
	},
	mounted() {
	},
	methods : {
		show() {
			AxiosHelper.get('/api/music/mixmatch').then(ret => {
				this.tableData = ret.data;
			});

			this.$refs.modal.show();
		},

		tableClick(index, data, event) {
			event.preventDefault();
			event.stopPropagation();

			if(event.currentTarget.dataset.type === 'execLink') {
				// if(!window.confirm('동일 노래인가요?')) {
				// 	return;
				// }

				const info = {
					song_path : (data.ky_song_path || data.tj_song_path)
				};

				if(data.ky_song_path) {	// KY에 노래가 있을경우 TJ가 등록대상
					info.media = data.tj_media;
					info.norae_no = data.tj_norae_no;
				}
				else if(data.tj_song_path) {	// TJ에 노래가 있을경우 KY가 등록대상
					info.media = data.ky_media;
					info.norae_no = data.ky_norae_no;
				}

				AxiosHelper.patch('/api/music/mixmatch', info).then(ret => {
					this.tableData = this.tableData.map((v, idx) => {
						if(idx === index.row) {
							v.ky_song_path = v.tj_song_path = (v.ky_song_path || v.tj_song_path);
						}
						return v;
					});
				});
			}
		},


	}
}
</script>

<template>
	<C.Modal ref="modal" title='믹스 매치'
		dialog-class-name="modal-dialog-scrollable modal-lg"
	>
		<C.Row>
			<C.Col lg="12">
				<Datatable
					:data="tableData"
					:option="tableOption"
					table-add-classes='table-xs'
					table-remove-classes='table-sm'
					@clickHandler="tableClick"
				>
					<template v-slot:thead>
						<tr>
							<th>KY</th>
							<th>액션</th>
							<th>TJ</th>
						</tr>
					</template>
				</Datatable>
			</C.Col>
		</C.Row>
	</C.Modal>
</template>